import React from 'react';
import { cn } from '../lib/utils';
import { CILogoIcon } from './CILogo';

export const CiScoreBadge = ({ score, size = 'md', showLogo = false }) => {
  const tier = score >= 800 ? 'aqua' : score >= 600 ? 'green' : score >= 300 ? 'amber' : 'red';
  
  const colorMap = {
    red: '#F55454',
    amber: '#FFC857',
    green: '#8CF78E',
    aqua: '#3EF1C7'
  };
  
  const sizeClasses = {
    sm: 'text-[11px] px-1.5 py-0.5 gap-1',
    md: 'text-xs px-2 py-0.5 gap-1.5',
    lg: 'text-sm px-2.5 py-1 gap-2'
  };

  const logoSizes = {
    sm: 'xs',
    md: 'xs',
    lg: 'sm'
  };
  
  const glow = tier === 'aqua' ? 'shadow-[0_0_24px_rgba(62,241,199,0.35)]' : '';
  
  return (
    <span
      data-testid="ci-score-badge"
      className={cn(
        'inline-flex items-center rounded-md border border-white/10 font-medium tabular-nums',
        sizeClasses[size],
        glow
      )}
      style={{
        background: 'rgba(255,255,255,0.04)',
        color: colorMap[tier]
      }}
    >
      {showLogo && (
        <CILogoIcon size={logoSizes[size]} variant="color" />
      )}
      {Math.round(score)}
    </span>
  );
};
